import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Jab pura app load ho jaye tab preloader ko remove karo
// const removePreloader = () => {
//   const preloader = document.getElementById("preloader");
//   if (preloader) {
//     preloader.style.opacity = "0";
//     setTimeout(() => {
//       preloader.remove();
//     }, 2000); // CSS transition ke liye wait
//   }
// };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// window.addEventListener("load", () => {
//   removePreloader();
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
